import {
  Content,
  Page,
} from '@trufla-technology/trumarket-react-design-system';
export const Dashboard = () => {
  return (
    <Content>
      <Page>
        <h1>Dashboard</h1>
      </Page>
    </Content>
  );
};
